import { signal } from '@preact/signals';
import { io as socketIO } from 'socket.io-client';
import { api } from './auth.js';

export const notifications = signal([]);
export const unreadCount = signal(0);

let socket = null;

export function connectSocket() {
  if (socket?.connected) return;

  socket = socketIO(window.location.origin, { autoConnect: true });

  socket.on('notification', (notification) => {
    // A load that ran just after the insert may already hold it
    if (notifications.value.some(n => n.id === notification.id)) return;
    notifications.value = [notification, ...notifications.value];
    unreadCount.value = unreadCount.value + 1;
  });

  socket.on('disconnect', () => {});
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export async function loadNotifications() {
  try {
    const data = await api('/api/notifications');
    notifications.value = data;
    unreadCount.value = data.filter(n => !n.is_read).length;
  } catch {
    // Silent fail
  }
}

export async function markAsRead(id) {
  await api(`/api/notifications/${id}/read`, { method: 'PATCH' });
  // Two quick clicks send two PATCHes: count only the one that turns it read
  const wasUnread = notifications.value.some(n => n.id === id && !n.is_read);
  notifications.value = notifications.value.map(n =>
    n.id === id ? { ...n, is_read: true } : n
  );
  if (wasUnread) unreadCount.value = Math.max(0, unreadCount.value - 1);
}

export async function markAllAsRead() {
  await api('/api/notifications/read-all', { method: 'POST' });
  notifications.value = notifications.value.map(n => ({ ...n, is_read: true }));
  unreadCount.value = 0;
}
